<template>
    <div class="modal fade" :id="''+id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('access.configurations.modification') }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <Input
                            containerClass="col-12 mt-2 mb-5"
                            :name="`${id}-name`"
                            type="text"
                            :label="$t('access.configurations.access_method')"
                            labelClass="form-label"
                            :inputClass="'form-control form-control-lg form-control-solid'"
                            :placeholder="$t('access.configurations.access_method')"
                            :isRequired="true" size="lg"
                            v-model="formData.access_name"
                            :readonly="true"
                        />
                        <Input
                            containerClass="col-12 mt-2 mb-5"
                            :name="`${id}-size`"
                            type="number"
                            :label="$t('access.configurations.pin_size')"
                            labelClass="form-label"
                            :inputClass="'form-control form-control-lg form-control-solid'"
                            :placeholder="$t('access.configurations.pin_size')"
                            :isRequired="false" size="lg"
                            v-model="formData.pin_size"
                            v-if="formData.access_name == 'Pin'"
                        />
                        <Input
                            containerClass="col-12 mt-2 mb-5"
                            :name="`${id}-number`"
                            type="number"
                            :label="$t('access.configurations.expired_time')"
                            labelClass="form-label"
                            :inputClass="'form-control form-control-lg form-control-solid'"
                            :placeholder="$t('access.configurations.expired_time')"
                            :isRequired="false" size="lg"
                            v-model="formData.expired_time"
                        />
                    </div>
                    <div class="modal-footer">
                        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingConfiguration"></Button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
    import {ref, defineProps, onMounted} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button.vue"
    import Input from "@/components/Input.vue";

    const store = useStore()

    const props = defineProps({
        form: { 
            type: Object, 
            default: {
                id: '',
                access_method_id: '',
                access_name: '',
                expired_time: 0,
                pin_size: 0,
                default: false
            } 
        },
        id: {
            type: String,
            required: true
        },
    })

    const emits = defineEmits(['load'])

    const formData = ref(props.form)
    const isLoadingConfiguration = ref(false)

    function submitData(){
        isLoadingConfiguration.value = true

        store.dispatch('configurations/updateConfig', formData.value)
            .then((response) => {
                emits('load')
                isLoadingConfiguration.value = false
                closeModal()
                formData.value.id= ''
                formData.value.access_method_id= ''
                formData.value.access_name= ''
                formData.value.expired_time= 0
                formData.value.pin_size= 0
                formData.value.default= false

                window.toastr['success'](i18n.global.t('notification.configuration_updated'))
            })
            .catch(err => {
                isLoadingConfiguration.value = false
            })
    }

    function closeModal(){
        $('#'+props.id).modal('toggle')
    }

    function loadMethods() {
        store.dispatch("methods/loadMethods")
    }

    onMounted(() => {
        loadMethods()
    })
</script>